const services = {
  title: "Service Offer",
  header: {
    overline: "PRICING & ENGAGEMENT",
    titlePrefix: "Tailored Solutions for",
    titleHighlight: "High-Impact",
    titleSuffix: "Products",
    subtitle:
      "Transparent pricing models designed to scale with your project needs, from initial strategy to full-scale production.",
  },
  pricing: {
    mostPopular: "Most Popular",
    packs: {
      advisory: {
        title: "Advisory",
        subtitle: "Strategic Guidance",
        price: "2 000 €",
        period: "/ project",
        description: "Ideal for validation and technical roadmap design.",
        features: ["Data Audit & Strategy", "Architecture Design", "Tech Stack Selection", "Performance Roadmap"],
        cta: "Book a Strategy Call",
      },
      build: {
        title: "Build",
        subtitle: "Implementation & AI",
        price: "550 €",
        period: "/ day",
        description: "End-to-end development of AI-driven features.",
        features: ["ML Implementation", "Smart API Development", "Data Pipelines (ETL)", "Backend Architecture"],
        cta: "Start Your Build",
      },
      scale: {
        title: "Scale",
        subtitle: "Growth & Maintenance",
        price: "6 000 €",
        period: "/ month",
        description: "Ongoing support for high-performance systems.",
        features: ["24/7 Monitoring & Support", "Model Fine-tuning", "Scale Infrastructure", "Product Iterations"],
        cta: "Contact for Scale",
      },
    },
  },
  productBased: {
    title: "Project-Based Solutions",
    subtitle: "Fixed-scope engagements for specific milestones and rapid prototyping.",
    poc: {
      title: "POC Data Science",
      description:
        "A 3-4 week deep dive to validate your data potential. Includes model prototyping, feasibility analysis, and a technical implementation roadmap.",
      price: "7 500 €",
      priceLabel: "Fixed Price",
    },
    mvp: {
      title: "MVP SaaS Data",
      description:
        "Full development of a functional product with AI core features. From UI/UX design to scalable cloud deployment in 8-12 weeks.",
      price: "15 000 €+",
      priceLabel: "Starts From",
    },
  },
  footerCta: {
    titlePrefix: "Ready to accelerate your",
    titleHighlight: "AI roadmap?",
    subtitle:
      "Whether you need a quick validation or a full-scale SaaS implementation, I'm here to help you turn complex data into competitive advantages.",
    button: "Schedule a Discovery Call",
  },
  caseStudies: {
    overline: "Proven Success",
    titlePrefix: "Real-World",
    titleHighlight: "Impact",
    subtitle: "From initial POCs to market-ready SaaS platforms. See how I help clients transform data into growth.",
    resultLabel: "Result",
    viewCase: "View Case",
  },
};

export default services;
